// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as ServiceIcons from './Icons';

import * as coreSelectors from '../core/selectors';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as accountSelectors from '../account/selectors';

import * as MessageFormat from './MessageFormat';
import * as coreActions from '../core/actions';
import DataTable from 'ui/DataTable';
import ActivityLayout from 'ui/ActivityLayout';
import { ACTIVITY_MESSAGE_TYPES, ACTIVITY_OPERATIONS, ACTIVITY_PAGES, ACTIVITY_VIEW_TYPES, GENERAL_FILTER_TYPES } from 'constants/activity.constants';
import FilterDialog from './FilterDialog';

const styles = theme => ({
  /* Message list container */
  messageList : {
    marginTop: 10,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  
});


/*
 * Activity list
 */

class Activity extends Component {

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.dataTableRef = React.createRef();
  }

  state = {
    scrollDisplay: 'flex',
    verifyUnread : false,
    verifyMessage : {},
    menuMessage : {},
    menuOpen : false,
    menuElement : null,
    verifyDuplicateContact : false,
    duplicateContactNumber : '',
    duplicateContactName : '',
    blockNumberDetailsMapping: {
      "OC": "outcallNumber",
      "VM": "ani",
      "IC": "ani"
    },
    tabSelected: 0,
    mouseState: 'left',
    mouseStatePdf: 'left',
    selectedMessages: [],
    selectedChatMessages: [],
    requestType: 'SELECT',
    companyFilterType: GENERAL_FILTER_TYPES.ALL,
    userFilterType: GENERAL_FILTER_TYPES.ALL,
    rememberFiltersChecked: false,
    rememberFiltersUpdated: false,
    loadedAtHeight: 0,
    startTime: null,
    endTime: null,
    loadedAll: false,
    canLoadMore: true,
    initLoadNumber: 0,
    hostsOnTest: ['dev', 'test', 'beta'],
    matchWord:false,
    showPdfExportOptions:false,
  }


  componentDidMount() {
    // Activity View
    if(!this.props.dashboard){
      document.title = 'Ruby - Activity'
    }
    this.updateActivityViewType();
    this.props.getReportFiles();
  }
  updateActivityViewType(prevProps){
    if(!prevProps || (prevProps && prevProps.dashboard !== this.props.dashboard) ){
        this.props.setActivityViewType(ACTIVITY_VIEW_TYPES.ALL)
    }
  }
  componentDidUpdate(prevProps, prevState){
    this.updateActivityViewType(prevProps)
    var openMessageId = parseInt(this.props.location.pathname.replace("/activity/",""));
    if(this.props.last20Messages?.userMessages?.length !== prevProps.last20Messages?.userMessages?.length){
      if(this.props.last20Messages && this.props.last20Messages.userMessages && this.props.last20Messages.userMessages.length >0){
        if(openMessageId !== "" && openMessageId >0){
          this.props.last20Messages.userMessages.forEach((item) => {
            if(openMessageId === item.messageId){
              this.props.openActivityDetail(item);
            }
    
          })
          
        }
      }
    }
  }

  loadMore = () => {
    this.props.getAllMessages({
      force: true,
      scrollEnd: true,
      start: this.state.startTime ? new Date(this.state.startTime) : undefined,
      end: this.state.endTime ? new Date(this.state.endTime) : undefined,
      completed: (result) => {
        if (result?.userMessages?.length === 0 && !this.state.loadedAll) {
          this.setState({ loadedAll: true });
        }
      },
    });
  }
  resetSelection(){
    this.dataTableRef?.current?.resetSelection()
    this.setState({selectedMessages: []})
  }
  toggleRead = (message) => {
    if(message.messageType === ACTIVITY_MESSAGE_TYPES.SMS && message.messageRead){
      this.setState({verifyUnread: true, verifyMessage: message});
    } else if (!message.read) {
      if(message.messageType !== ACTIVITY_MESSAGE_TYPES.CHAT){
        this.props.markMessageRead(message.messageId);
      } else {
        this.props.markPurechatRead(message.chatId, 'N');
      }
    } else {
      this.setState({verifyUnread: true, verifyMessage: message});
    }
  }

  markUnread = (message) => {
    this.setState({verifyUnread: false});
    if(this.state.verifyMessage.messageType === ACTIVITY_MESSAGE_TYPES.CHAT){
      this.props.markPurechatRead(this.state.verifyMessage.chatId, 'Y');
      return;
    }
    this.props.unmarkMessageRead(this.state.verifyMessage.messageId);
  }

  /* Search a text field for a keyword */
  searchField(field, search) {
    if (typeof(field) !== 'string') {
      return(false);
    }
    if (typeof(search) !== 'string' || search.length === 0) {
      return(false);
    }
    return(field.toUpperCase().includes(search));
  }

  getMessageId = (message)=>{
    if(message.messageType === ACTIVITY_MESSAGE_TYPES.AGENT_VM){
      return message.combinedMessageId
    } else if((message.deliveryId && message.userId === this.props.user.userId) || message.messageType === ACTIVITY_MESSAGE_TYPES.SMS){
      return message.messageId
    } else if(message.messageType === ACTIVITY_MESSAGE_TYPES.CHAT) {
      return message.chatId
    }
}


  generatePdfReportOptions = () => {
    this.setState({showPdfExportOptions:true})
  }

  generatePdfReport = () => {
    let minDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
    let maxDate = new Date(new Date());
    if(this.state.startTime !== null){
      minDate = new Date(this.state.startTime);
      minDate.setHours(0,0,0,0)
    }
    if(this.state.endTime !== null){
      maxDate = new Date(this.state.endTime);
      maxDate.setHours(24,0,0,0)
    }

    console.log(Math.floor((maxDate - minDate) / (1000*60*60*24)));
     if(this.props.filterSearch.trim().length <= 2){
      return;
    }
    if(Math.floor((maxDate - minDate) / (1000*60*60*24)) >31){
      this.props.postSnackMessage('error', '','PDF export can only load max of 31 days');
      return;
    }
    this.props.generatePdf(this.props.filterListText, null, minDate, maxDate,this.props.filterSearch.toUpperCase(),this.state.selectedMessages,this.state.matchWord ? 'Y' : 'N');
  }

  generateCSVReport = () => {
    let minDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
    let maxDate = new Date(new Date());
    if(this.state.startTime !== null){
      minDate = new Date(this.state.startTime);
      minDate.setHours(0,0,0,0)
    }
    if(this.state.endTime !== null){
      maxDate = new Date(this.state.endTime);
      maxDate.setHours(24,0,0,0)
    }
    if(Math.floor((maxDate - minDate) / (1000*60*60*24)) >31){
      this.props.postSnackMessage('error', '','CSV export can only load max of 31 days');
      return;
    }
    this.props.generateCSV(this.props.filterType, null, minDate, maxDate, (this.props.filterSearch || '').trim().toUpperCase(), (this.state.selectedMessages || []).join(','));
  }

  bulkOperationSelected = (operation) => {
    if(operation === ACTIVITY_OPERATIONS.UNREAD){ this.props.bulkUnmarkMessageRead(this.state.selectedMessages, undefined) }
    if(operation === ACTIVITY_OPERATIONS.READ){ this.props.bulkMarkMessageRead(this.state.selectedMessages, undefined) }
    if(operation === ACTIVITY_OPERATIONS.FLAG){ this.props.toggleBulkFollowup(this.state.selectedMessages, undefined, this.props.dashboard, 'Y') }
    if(operation === ACTIVITY_OPERATIONS.UNFLAG){ this.props.toggleBulkFollowup(this.state.selectedMessages, undefined, this.props.dashboard, 'N') }
    if(operation === ACTIVITY_OPERATIONS.ARCHIVE){ this.props.bulkArchiveMessage(this.state.selectedMessages, undefined) }
    if(operation === ACTIVITY_OPERATIONS.UNARCHIVE){ this.props.bulkUnarchiveMessage(this.state.selectedMessages, undefined) }
    this.resetSelection()
  }

  getMessages(){
    const { user,
      filters, 
      filterDays, filterSearch,
      activityViewType, last20Messages } = this.props;


const { companyFilterType } = this.state;

    /* The dashboard view passes this as true for the minimal view */
    let dashboard = Boolean(this.props.dashboard);
    /* See if any of the filters are set or we don't filter at all */
    let filtersSet = false;
    Object.keys(filters).forEach(filterKey => {
      if (filters[filterKey].active) {
        filtersSet = true;
      }
    });
    let searchText = filterSearch.trim().toUpperCase();
    /* Remove common formatting characters from the search string
       for matching phone number fields */
    let phoneSearchText = searchText.replace(/[()-\s]/g, '');

    /* Get the message list based on the view type.  On the dashboard
       we only show the user messages  */
    let messageList = last20Messages?.userMessages ?? [];
     //  On the main view filter by company filter types
     if(!dashboard && companyFilterType !== GENERAL_FILTER_TYPES.ALL){
      messageList = messageList?.filter(message => message.accountId === companyFilterType) || [];
    }
    // if (!dashboard) {
    //   if(companyFilterType === GENERAL_FILTER_TYPES.ALL && userFilterType === GENERAL_FILTER_TYPES.ALL){
    //     // messageList = last20Messages.userMessages || [];
    //   } else if(companyFilterType === GENERAL_FILTER_TYPES.ALL && userFilterType !== GENERAL_FILTER_TYPES.ALL) {
    //     messageList = messageList?.filter(message => message.userId === user.userId || message.messageType === ACTIVITY_MESSAGE_TYPES.SMS || message.messageType === ACTIVITY_MESSAGE_TYPES.CHAT) || [];
    //   } else if(companyFilterType !== GENERAL_FILTER_TYPES.ALL && userFilterType === GENERAL_FILTER_TYPES.ALL){
    //     messageList = messageList?.filter(message => message.accountId === companyFilterType) || [];
    //   } else {
    //     messageList = messageList?.filter(message => (message.accountId === companyFilterType && message.userId === user.userId) || (message.messageType === ACTIVITY_MESSAGE_TYPES.SMS && message.accountId === companyFilterType)) || [];
    //   }
    // }
    let messagesFiltered = messageList.filter(message => {
      /* Always keep messages with hold set.  This is set when
         changing the read, archive or followup status but we don't want it
         to immediately vanish if the current filter removes it.  They
         need to click query or change the filter settings to remove the
         holds */
      // if (message.hold) {
      //   return(true);
      // }
      
       // Filter out the dashboard messages here
       if(dashboard){
        //  No Archived messages on dashboard page
        if(message.archived || message.messageArchived){
          return false
        }
        // default fallback
        else{
          return true
        }
      }
      // Filter out activity for the main activity view
      // 1. Filter out for archieved tab
      if(activityViewType === ACTIVITY_VIEW_TYPES.ARCHIVED && !(message.messageArchived || message.archived)){
          return false
      }
      //  Remove Archived messages from all tab
      if(activityViewType !== ACTIVITY_VIEW_TYPES.ARCHIVED && (message.messageArchived || message.archived)){
        return false
      }
      
      /* 2. No go through all the specific exclusive filters if any are set */
      if (filtersSet) {
        let match = false;
        if (filters.leads.active && message.callTagName === 'PNC / Lead') {
          match = true;
        }
        if (filters.currentClients.active && message.callTagName === 'Current Client') {
          match = true;
        }
        if (filters.assists.active && (message.messageType === 'TASK' || message.messageType === 'CS' || message.messageType === 'TEXT' )) {
          match = true;
        }
        if (filters.flagged.active && message.followup === 'Y') {
          match = true;
        }
        if (filters.outboundCalls.active && message.messageType === 'OC') {
          match = true;
        }
        if (filters.inboundCalls.active && message.messageType === 'IC') {
          match = true;
        }
        if (filters.messages.active && message.messageType === 'AGENT') {
          match = true;
        }
        if (filters.voicemail.active && (message.messageType === 'VM' || message.messageType === 'AGENT+VM')) {
          match = true;
        }
        if (filters.vip.active && (message.messageType === 'VIP')) {
          match = true;
        }
        if (filters.unread.active && !(message.read || message.messageRead) && message.messageType !== 'CS' && message.messageType !== 'IC'){
          if(message.userId === user.userId || message.messageType === 'SMS' || message.messageType === 'CHAT'){
            match = true;
          }
        }
        if (filters.roboCalls.active && message.taskStatus === 'BLOCKED'){
          match = true;
        }
        if (!match) {
          return(false);
        }
      }
      
      /* 3. Filter out by search string if set */
      if (searchText.length > 0) {
        
        /* Text content */
        if (this.searchField(message.textContent, searchText)) {
          return(true);
        }
        
        /* Form content only search the values */
        if (message.formContent) {
          let formContent = JSON.parse(message.formContent);
          for (let i=0; i< formContent.fields.length; i++) {
            if (this.searchField(formContent.fields[i].value, searchText)) {
              return(true);
            }
          }
        }
        
        /* Recording Transcription */
        if (this.searchField(message.recordingTranscription, searchText)) {
          return(true);
        }
        
        /* User name that created task */
        if (this.searchField(message.taskUser, searchText)) {
          return(true);
        }
        
        /* Caller name */
        if (this.searchField(message.caller, searchText)) {
          return(true);
        }
        
        /* ANI */
        if (this.searchField(message.ani, phoneSearchText)) {
          return(true);
        }
        
        /* DNIS */
        if (this.searchField(message.dnis, phoneSearchText)) {
          return(true);
        }
        
        /* Outcall number */
        if (this.searchField(message.outcallNumber, phoneSearchText)) {
          return(true);
        }
        
        /* Outcall source */
        if (this.searchField(message.outcallSourceNumber, phoneSearchText)) {
          return(true);
        }
        
        /* Request text */
        if (this.searchField(message.request, searchText)) {
          return(true);
        }

        if(this.searchField(MessageFormat.messageDetail(message,this.props.user), searchText)){
          return(true);
        }

        if(this.searchField(MessageFormat.getToDetails(message, this.props.user), searchText)){
          return(true);
        }
        
        /* No match */
        return(false);
      }
      // default fallback
      return(true);
    });

    if(filterDays !== null){
      let minDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
      let maxDate = new Date(new Date());
      if(this.state.startTime !== null){
        minDate = new Date(this.state.startTime);
        minDate.setHours(0,0,0,0)
      }
      if(this.state.endTime !== null){
        maxDate = new Date(this.state.endTime);
        maxDate.setHours(24,0,0,0)
      }
      messagesFiltered = messagesFiltered?.filter(message => (new Date(message?.taken).getTime() > minDate.getTime() && new Date(message?.taken).getTime() < maxDate.getTime()) ||
                                                            (new Date(message?.lastMessage).getTime() > minDate.getTime() && new Date(message?.lastMessage).getTime() < maxDate.getTime()));                                                  
      if(this.state.hostsOnTest.filter(item => window.location.host.includes(item)).length > 0){
        // console.log("loadedAll", this.state.loadedAll)
        // console.log("lastMessage", lastMessage);
      }
    }

    // let sectionHeader = '';
    if(messagesFiltered.length < 30 && last20Messages?.userMessages?.length > 0 && this.state.canLoadMore && this.state.initLoadNumber < 6){
      this.setState({canLoadMore: false, initLoadNumber: this.state.initLoadNumber + 1})
      this.props.getAllMessages({
        force: true,
        scrollEnd: true,
        start: this.state.startTime
          ? new Date(this.state.startTime)
          : undefined,
        end: this.state.endTime ? new Date(this.state.endTime) : undefined,
        completed: (result) => {
          if (result.userMessages.length === 0) {
            this.setState({ loadedAll: true });
          } else if (
            result.userMessages.length > 0 ||
            result.pureChats.length > 0
          ) {
            this.setState({ canLoadMore: true });
          }
        },
      });
    }
    
    messagesFiltered.sort((a, b)  => (new Date(b.taskEndTime).getTime() - new Date(a.taskEndTime).getTime()))

    if(this.state.hostsOnTest.filter(item => window.location.host.includes(item)).length > 0){
      //console.log(messagesFiltered);
    }
    return messagesFiltered
  }
  render() {
    const { classes, user,
             filterListText, 
            openActivityDetail, toggleFollowup, markPurechatFollowup,
            activityViewType } = this.props;
            
   const messagesFiltered = this.getMessages();
      const dashboardColumns = [
        {
          heading: "type",
          textAlign:'left',
          renderCell: (message) => {
            let changeable = (message.deliveryId && message.userId === user.userId) || message.messageType === 'SMS' || message.messageType === 'CHAT';
            return (
              <div className={classes.messageIcon}>
              <MuiCore.Hidden>
                <MuiCore.IconButton
                  onClick={(event) => {
                    this.toggleRead(message)
                    event.stopPropagation();
                  }}
                  style={{color: (message.read || message.messageRead) ? '#D6D7DB' : changeable ? '#122457' : '#D6D7DB'}}
                  disabled={!changeable}>
                  {ServiceIcons.IconForType(message, user.userId, {color: (message.read || message.messageRead) ? '#D6D7DB' : changeable ? '#122457' : '#D6D7DB'})}
                </MuiCore.IconButton> 
              </MuiCore.Hidden>
            </div>
            );
          },
        },
        {
          heading: "from",
          textAlign:'left',
          renderCell: (message) => {
            return (
                message.combinedDisplayName
                  ? message.combinedDisplayName
                  : `${MessageFormat.messageDetail(message, user)}`
            );
          },
        },
        {
          heading: "to",
          textAlign:'left',
          renderCell: (message) => {
            return (MessageFormat.getToDetails(message, user));
          },
        },
        {
          heading: "Tag",
          textAlign:'left',
          renderCell: (message) => {
            return message.callTagName
          },
        },
        {
          heading: "Date/Time",
          textAlign:'left',
          renderCell: (message) => {
            return (MessageFormat.formatDateTime(message)
            );
          },
        },
        {
          heading: "",
          textAlign:'right',
          renderCell: (message) => {
            let changeable = (message.deliveryId && message.userId === user.userId) || message.messageType === 'SMS' || message.messageType === 'CHAT';
            return (
              <>
                {message &&
                  message.billableAgentMinutes > 0 &&
                  message.lastMessageId &&
                  message.messageId === message.lastMessageId && (
                    <MuiCore.Chip label="Billable"></MuiCore.Chip>
                  )}
                <MuiCore.IconButton
                  color="primary"
                  disabled={!changeable}
                  onClick={(event) => {
                    if (message.messageType !== ACTIVITY_MESSAGE_TYPES.CHAT) {
                      toggleFollowup(message, this.props.dashboard);
                    } else {
                      if (message.followup === "Y") {
                        markPurechatFollowup(message.chatId, "N");
                      } else {
                        markPurechatFollowup(message.chatId, "Y");
                      }
                    }
                    event.stopPropagation();
                  }}
                >
                  <ServiceIcons.FollowupIcon
                    followup={message.followup}
                    messageFollowup={message.messageFollowup}
                    style={{
                      color:
                        message.followup === "Y" ||
                        message.messageFollowup === "Y"
                          ? "#e5136c"
                          : changeable
                          ? "#000"
                          : "",
                    }}
                  />
                </MuiCore.IconButton>
              </>
            );
          },
        },
      ]
      const activityColumns = [
        dashboardColumns[0],
        dashboardColumns[1],
        dashboardColumns[2],
        {
          heading:'Company',
          textAlign:'left',
          renderCell: (message)=>{
            return(
                MessageFormat.getCompany(message,this.props.user)
            )
          }
        },
        {
          heading: "Outcome",
          textAlign:'left',
          renderCell: (message) => {
            return (message?.contactDescription || ""
            );
          },
        },
        dashboardColumns[3],
        dashboardColumns[4],
        dashboardColumns[5],
      ];
      // console.log("selectedIds", this.state.selectedMessages, [...new Set(this.state.selectedMessages)])
    return (
      <React.Fragment>
        <FilterDialog
          type={ACTIVITY_PAGES.ACTIVITY}
        />
        <ActivityLayout
          dashboard={this.props.dashboard}
          hideFilters={this.props.dashboard}
          isLoading={this.props.showLoading}
          page={ACTIVITY_PAGES.ACTIVITY}
          onTabChange={()=>{
            this.resetSelection()}}
          popups={[
            {
              open: this.state.verifyUnread,
              title: "Reset To Unread",
              text: "Do you wish to clear the read date of this activity?",
              actions: [
                {
                  text: "Clear Read Date",
                  onClick: this.markUnread,
                },
                {
                  text: "Cancel",
                  onClick: () => this.setState({ verifyUnread: false }),
                },
              ],
              onClose: () => this.setState({ verifyUnread: false }),
            },
            {
              open: this.state.showPdfExportOptions,
              title: "Export PDF",
              text: `Searching for "${this.props.filterSearch.toUpperCase()}"`,
              component: (
                <MuiCore.Grid container>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.FormControlLabel
                      fullWidth
                      control={
                        <MuiCore.Checkbox
                          checked={this.state.matchWord}
                          value={this.state.matchWord}
                          onChange={(event) =>
                            this.setState({ matchWord: event.target.checked })
                          }
                          name="checkedB"
                          color="secondary"
                        />
                      }
                      label={
                        this.state.matchWord
                          ? "When this box is checked, only results containing the exact word(s) will be exported. "
                          : "When this box is unchecked, any results containing a partial match will be exported."
                      }
                    />
                  </MuiCore.Grid>
                </MuiCore.Grid>
              ),
              actions: [
                {
                  text: "Export",
                  onClick: this.generatePdfReport,
                },
                {
                  text: "Cancel",
                  onClick: () => this.setState({ showPdfExportOptions: false }),
                },
              ],
              onClose: () => this.setState({ showPdfExportOptions: false }),
            },
          ]}
          onPdfClick={this.generatePdfReportOptions}
          onCsvClick={this.generateCSVReport}
          csvDisabled={messagesFiltered.length === 0}
          renderFilters={{
            filterListText,
            onClick: () => this.props.setShowFilterDialog(true),
          }}
          companyFilterType={this.state.companyFilterType}
          startTime={this.state.startTime}
          endTime={this.state.endTime}
          popupFilters={this.props.filters}
          onCompanyFilterChange={(value) => {
            this.setState({ companyFilterType: value });
          }}
          onStartTimeChange={(value) => {
            this.setState({ initLoadNumber: 0, startTime: value });
          }}
          onEndTimeChange={(value) => {
            this.setState({ initLoadNumber: 0, endTime: value });
          }}
        >
          <div ref={this.containerRef} className={classes.messageList}>
            <DataTable
              enableNoContentPlaceholder
              ref={this.dataTableRef}
              getRowId={this.getMessageId}
              marginTop={0}
              onRowClick={(message) => {
                this.props.getBlockNumbersByAccount(message.accountId);
                openActivityDetail(message);
              }}
              onSelectionChange={(selectedIds, selectedData) => {
                if (!this.props.dashboard) {
                  this.setState({ selectedMessages: selectedIds });
                }
              }}
              onSelectComponent={() => {
                return (
                  <div>
                    <MuiCore.Select
                      variant="outlined"
                      placeholder="Select"
                      onChange={(event) => {
                        this.bulkOperationSelected(event.target.value);
                      }}
                      style={{ width: 150 }}
                      inputProps={{
                        style: { fontFamily: "Sofia", fontSize: 14 },
                      }}
                      renderValue={() => {
                        if (this.state.requestType === "SELECT") {
                          return "Select";
                        }
                      }}
                      value={this.state.requestType}
                    >
                      <MuiCore.MenuItem key="READ" value="READ">
                        Mark Read
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="UNREAD" value="UNREAD">
                        Mark Unread
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="FLAG" value="FLAG">
                        Flag
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="UNFLAG" value="UNFLAG">
                        Unflag
                      </MuiCore.MenuItem>
                      {activityViewType !== "archived" && (
                        <MuiCore.MenuItem key="ARCHIVE" value="ARCHIVE">
                          Archive
                        </MuiCore.MenuItem>
                      )}
                      {activityViewType === "archived" && (
                        <MuiCore.MenuItem key="UNARCHIVE" value="UNARCHIVE">
                          Unarchive
                        </MuiCore.MenuItem>
                      )}
                    </MuiCore.Select>
                  </div>
                );
              }}
              enableSelect={!this.props.dashboard}
              columns={
                this.props.dashboard ? dashboardColumns : activityColumns
              }
              data={messagesFiltered}
            />

            {messagesFiltered.length > 0 && !this.props.dashboard && (
              <MuiCore.Grid
                style={{ width: "100%", textAlign: "center", marginTop: 10 }}
              >
                <MuiCore.Typography
                  style={{ fontFamily: "Sofia", fontSize: 20 }}
                >
                  Showing 1 - {messagesFiltered.length}
                </MuiCore.Typography>
                {this.state.loadedAll ? (
                  <MuiCore.Typography
                    style={{ fontFamily: "Sofia", fontSize: 20 }}
                  >
                    Please change the start date to load more
                  </MuiCore.Typography>
                ) : (
                  <MuiCore.Button
                    onClick={() => this.loadMore()}
                    style={{ marginTop: 10 }}
                  >
                    Load More
                  </MuiCore.Button>
                )}
              </MuiCore.Grid>
            )}
          </div>
        </ActivityLayout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    // messages : serviceSelectors.getMessages(state),
    refreshing : serviceSelectors.getUpdatingMessages(state),
    filters : serviceSelectors.getFilters(state),
    filterListText : serviceSelectors.getFilterListText(state),
    filterSearch : serviceSelectors.getFilterSearch(state),
    filterDays : serviceSelectors.getFilterDays(state),
    filterAccountId : serviceSelectors.getFilterAccountId(state),
    activityViewType : serviceSelectors.getActivityViewType(state),
    pdfContent: serviceSelectors.getPdfContent(state),
    accountId: accountSelectors.getAccountId(state),
    blockNumbersAccount: serviceSelectors.getBlockNumbersByAccount(state),
    last20Messages: serviceSelectors.getLast20Messages(state),
    showLoading: serviceSelectors.getShowLoading(state),
    reportFiles: serviceSelectors.getReportFiles(state),
  });
};

const mapDispatchToProps = {
  setFilters: serviceActions.setFilters,
  setShowFilterDialog : serviceActions.setShowFilterDialog,
  setFilterType : serviceActions.setFilterType,
  setFilterSearch : serviceActions.setFilterSearch,
  setFilterDays : serviceActions.setFilterDays,
  setFilterAccountId : serviceActions.setFilterAccountId,
  setFilterLocationId : serviceActions.setFilterLocationId,
  openActivityDetail : serviceActions.openActivityDetail,
  updateMessages : serviceActions.updateMessages,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  toggleFollowup : serviceActions.toggleFollowup,
  setActivityViewType : serviceActions.setActivityViewType,
  clearHolds : serviceActions.clearHolds,
  setContactsSearchText : serviceActions.setContactsSearchText,
  newContact : serviceActions.newContact,
  openAssist : serviceActions.openAssist,
  manualTransfer : serviceActions.manualTransfer,
  generatePdf: serviceActions.generatePdfReport,
  generateCSV: serviceActions.generateCsvReport,
  blockPhoneNumber: serviceActions.blockPhoneNumber,
  unblockPhoneNumber: serviceActions.unblockPhoneNumber,
  getBlockNumbersByAccount:serviceActions.blockNumbersByAccount,
  downloadVoiceMail: serviceActions.downloadVoiceMail,
  bulkMarkMessageRead: serviceActions.bulkMarkMessageRead,
  bulkUnmarkMessageRead: serviceActions.bulkUnmarkMessageRead,
  bulkArchiveMessage: serviceActions.bulkArchiveMessage,
  bulkUnarchiveMessage: serviceActions.bulkUnarchiveMessage,
  toggleBulkFollowup: serviceActions.toggleBulkFollowup,
  updateFilters : serviceActions.updateFilters,
  getAllMessages: serviceActions.getAllMessages,
  markPurechatRead: serviceActions.markPurechatRead,
  markPurechatArchived: serviceActions.markPurechatArchived,
  markPurechatFollowup: serviceActions.markPurechatFollowup,
  postSnackMessage : coreActions.postSnackMessage,
  getReportFiles: serviceActions.getReportFiles,
  getSignedUrl: serviceActions.getSignedUrl,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Activity)));


